import { TweenMax, TimelineMax } from 'gsap';

export default class Header {

	constructor() {
		this.instance = self;
		this.lst = 0;
		this.isVisible = true;
	}



	static init() {
		const self = new Header;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(window).on('scroll', function(){
			self.refreshFixedHeader();
		});

		if (Modernizr.touchevents) {
			$(window).on('touchmove', function(e) {
				self.refreshFixedHeader();
			});

			$(window).on('touchend', function(e) {
				self.refreshFixedHeader();
			});
		}

        $( document ).ready(function() {
            const url = window.location.href;
            // Check if URL contains 'bibis-showtime' and '?month='
            if (url.includes('bibis-showtime') && url.includes('?month=')) {
                // Extract everything after '?month='
                const monthIndex = url.indexOf('?month=');
                if (monthIndex !== -1) {
                    let paramString = url.substring(monthIndex + 7); // 7 is length of '?month='
                    // If there are other params after, split at '&'
                    const ampIndex = paramString.indexOf('&');
                    if (ampIndex !== -1) {
                        paramString = paramString.substring(0, ampIndex);
                    }
                    if ( $(window).width() > 1200 ) {
                        $('#' + paramString + '-tab').trigger('click');
                    }else{
                        $('.showtime-' + paramString ).trigger('click');
                    }
                }
            }
        });
	}


	showFixedHeader() {
		const self = this;

		var $header = $('.header');

		if (!self.isVisible) {
			self.isVisible = true;

			TweenMax.fromTo($header, 0.2, {
				y: '-100%'
			}, {
				y: '0%'
			});
		}
	}

	hideFixedHeader() {
		const self = this;

		var $header = $('.header');

		if (self.isVisible) {
			self.isVisible = false;

			TweenMax.fromTo($header, 0.2, {
				y: '0%'
			}, {
				y: '-100%'
			});
		}
	}

	refreshFixedHeader() {
		const self = this;

		var st = $(window).scrollTop(),
			scrollDiff = st - self.lst;

		if (st > $('.header').outerHeight()) {
			if (st <= self.lst){
				self.showFixedHeader();
			} else {
				self.hideFixedHeader();
			}
		} else {
			self.showFixedHeader();
		}

		if (scrollDiff >= 100 || scrollDiff <= -100) {
			self.lst = st;
		}
	}
}
